// ProjectRequest 用の dirty 判定・表示安定化用の正規化
export const comparableProjectRequest = (state) => ({
  desired_amount:
    state.desired_amount === "" || state.desired_amount == null
      ? ""
      : String(state.desired_amount),
  start_date: state.start_date ?? "",
  technical_skill: state.technical_skill?.trim() || "",
  remark: state.remark?.trim() || "",
  work_style: state.work_style ?? "on_site",
});

// JobRequest 用の dirty 判定・表示安定化用の正規化
export const comparableJobRequest = (state) => ({
  desired_joining_date: state.desired_joining_date || "",
  expected_retirement_date: state.expected_retirement_date || "",
  expected_salary_min:
    state.expected_salary_min == null || state.expected_salary_min === ""
      ? ""
      : String(state.expected_salary_min),
  expected_salary_max:
    state.expected_salary_max == null || state.expected_salary_max === ""
      ? ""
      : String(state.expected_salary_max),
  prefecture_ids: Array.isArray(state.prefecture_ids)
    ? state.prefecture_ids
    : [],
  desired_employment_type: state.desired_employment_type || "full_time",
  remark: state.remark?.trim() || "",
  current_salary:
    state.current_salary == null || state.current_salary === ""
      ? ""
      : String(state.current_salary),
  career_change_count:
    state.career_change_count == null || state.career_change_count === ""
      ? ""
      : String(state.career_change_count),
  previous_companies_and_reasons:
    state.previous_companies_and_reasons?.trim() || "",
  current_change_reason: state.current_change_reason?.trim() || "",
  recruiting_flag: state?.recruiting_flag ?? true,
});
